// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tab-btn[data-v-5c808caa] {
  position: relative;
  height: 100%;
}
.tab-btn .btn[data-v-5c808caa] {
  position: absolute;
  right: 0;
  top: -2px;
}
.tab-btn .table[data-v-5c808caa] {
  height: calc(100% - 35px);
}
`, "",{"version":3,"sources":["webpack://./src/components/TabBtn/index.vue","webpack://./index.vue"],"names":[],"mappings":"AACA;EACE,kBAAA;EACA,YAAA;ACAF;ADFA;EAII,kBAAA;EACA,QAAA;EACA,SAAA;ACCJ;ADPA;EASI,yBAAA;ACCJ","sourcesContent":["\n.tab-btn {\n  position: relative;\n  height: 100%;\n  .btn {\n    position: absolute;\n    right: 0;\n    top: -2px;\n  }\n  .table {\n    height: calc(100% - 35px);\n  }\n}\n",".tab-btn {\n  position: relative;\n  height: 100%;\n}\n.tab-btn .btn {\n  position: absolute;\n  right: 0;\n  top: -2px;\n}\n.tab-btn .table {\n  height: calc(100% - 35px);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
